import { K2Chart } from './K2Chart';
import { COMPARE_COLUMNS, DAY_COLUMNS, WEEK_COLUMNS, SimpleTable } from './K2Tables';
import { byDay, byWeek } from './k2utils';

const C = { b290: '#0EA5E9', b291: '#8B5CF6', moves: '#16A34A', prev: '#94A3B8', losses: '#DC2626', lossesPrev: '#FCA5A5' };

function compareData(moves, nes, r) {
  const cur = byDay(moves, nes, r.from, r.to);
  const prev = byDay(moves, nes, r.prevFrom, r.prevTo);
  return cur.map((d, i) => ({ label: prev[i] ? `${d.label} / ${prev[i].label.slice(3)}` : d.label, moves: d.moves, prevMoves: prev[i]?.moves || 0, losses: d.losses, prevLosses: prev[i]?.losses || 0 }));
}

const COMPARE_SERIES = [
  { key: 'moves', name: 'Pohyby – aktuální', color: C.moves },
  { key: 'prevMoves', name: 'Pohyby – předchozí', color: C.prev, dashed: true },
  { key: 'losses', name: 'Ztráty – aktuální', color: C.losses },
  { key: 'prevLosses', name: 'Ztráty – předchozí', color: C.lossesPrev, dashed: true },
];
const DAY_SERIES = [
  { key: 'b290', name: 'Výdeje 290', color: C.b290, stack: 'm' },
  { key: 'b291', name: 'Výdeje 291', color: C.b291, stack: 'm' },
  { key: 'losses', name: 'Ztráty NES', color: C.losses },
];
const LINE_SERIES = [
  { key: 'moves', name: 'Pohyby celkem', color: C.moves },
  { key: 'losses', name: 'Ztráty NES', color: C.losses },
];

export const K2Analysis = ({ mode, view, moves, nes, range, cur, prev }) => {
  if (mode === 'compare') {
    if (view === 'table') {
      const rows = [
        { name: 'Výdeje 290', cur: cur.b290, prev: prev.b290 },
        { name: 'Výdeje 291', cur: cur.b291, prev: prev.b291 },
        { name: 'Pohyby celkem', cur: cur.moves, prev: prev.moves },
        { name: 'Ztráty NES (dle data šarže)', cur: cur.losses, prev: prev.losses },
        { name: 'Počet dokladů', cur: cur.docs, prev: prev.docs, count: true },
      ];
      return <SimpleTable testId="k2-compare-table" columns={COMPARE_COLUMNS} rows={rows} rowKey={(r) => r.name} />;
    }
    return <K2Chart testId="k2-compare-chart" type={view} data={compareData(moves, nes, range)} series={COMPARE_SERIES} />;
  }
  const rows = mode === 'weekly' ? byWeek(moves, nes, range.from, range.to) : byDay(moves, nes, range.from, range.to);
  if (view === 'table') {
    return <SimpleTable testId={`k2-${mode}-table`} columns={mode === 'weekly' ? WEEK_COLUMNS : DAY_COLUMNS} rows={rows} rowKey={(r) => r.key || r.date} />;
  }
  return <K2Chart testId={`k2-${mode}-chart`} type={view} data={rows} series={view === 'line' ? LINE_SERIES : DAY_SERIES} />;
};
